module.exports = __webpack_public_path__ + "static/img/1-16.2049ebe.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/home/1-16.png
// module id = Ms6b
// module chunks = 15